import { schema } from 'normalizr';
import { pickAll } from 'ramda';

import { keysToCamelCase, keysToSnakeCase } from 'utils/stringUtils';

export const parseManufacturer = (data) => {
  return keysToCamelCase(data);
};

export const parseMachine = (data) => {
  return keysToCamelCase(data);
};

export const parseVariable = (data) => {
  return keysToCamelCase(data);
};

export const encodeVariable = (data) => {
  return keysToSnakeCase(data);
};

export const parseFormula = (data) => {
  const result = keysToCamelCase(data);
  result.variables = result.variables.map(parseVariable);
  return result;
};

export const parseOpDef = (data) => {
  const result = keysToCamelCase(data);
  if (result.machine) {
    result.machine = parseMachine(result.machine);
    result.machine.manufacturer = parseManufacturer(
      result.machine.manufacturer,
    );
  }
  if (result.formula) {
    result.formula = parseFormula(result.formula);
  }
  return result;
};

export const encodeOpDef = (data) => {
  const result = keysToSnakeCase(
    pickAll(
      [
        'annualMaintenance',
        'category',
        'depreciationYears',
        'description',
        'expectedUtilizationRate',
        'interestRate',
        'modifiers',
        'name',
        'purchasePrice',
        'runtimeDisplayUnits',
        'setupTimeDisplayUnits',
      ],
      data,
    ),
  );
  if (data.machine) {
    result.machine_id = data.machine.id;
  }
  return result;
};

export const variableSchema = new schema.Entity('variables');

export const processClassSchema = new schema.Entity('processClasses');

export const manufacturerSchema = new schema.Entity('manufacturers');

export const machineSchema = new schema.Entity('machines', {
  manufacturer: manufacturerSchema,
});

export const processClassManufacturerSchema = new schema.Entity(
  'processClassManufacturers',
  {
    manufacturers: [manufacturerSchema],
  },
);

export const processClassManufacturerMachineSchema = new schema.Entity(
  'processClassManufacturerMachines',
  {
    machines: [machineSchema],
  },
);

export const opDefSchema = new schema.Entity('opDefs', {
  machine: machineSchema,
  formula: {
    variables: [variableSchema],
  },
});
